// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__PxZep","loadingShrink":"PageLoading_loadingShrink__1zogC"};